import React, { useState } from 'react';
import useStyle from './ClassObjective.style';
import { useQuery } from '@apollo/client';
import Objective from 'components/organisms/ClassObjective/Objective';
import ObjectiveUpdate from 'components/organisms/ClassObjective/ObjectiveUpdate';
import { QUERY_CLASSE_INFO } from '../../../graphql/query/classe/queryClasseInfos';
import { GetCurrentClasseInfoQuery } from '../../../graphql/generated/graphql';
import { IS_PROF } from 'helpers/user/authorization';

const ClassObjective = () => {
  const classes = useStyle();
  const [showObjective, setShowObjective] = useState(true);

  const { data, loading, error } = useQuery<GetCurrentClasseInfoQuery>(
    QUERY_CLASSE_INFO
  );
  if (loading) return <p>Chargement de l'objectif</p>;
  if (error) return <p>Erreur lors du chargement de l'objectif</p>;

  const myClass = data?.getCurrentClasseInfos;

  return (
    <div className={classes.root}>
      {myClass.objectif ? (
        showObjective ? (
          <Objective
            nameObjective={myClass.objectif.name}
            caObjective={parseInt(myClass.objectif.ca)}
            currentCa={parseInt(myClass.noteclasse.qteca)}
            isProf={IS_PROF}
            setShowObjective={setShowObjective}
          />
        ) : (
          <ObjectiveUpdate
            nameObjective={myClass.objectif.name}
            caObjective={myClass.objectif.ca}
            action="put"
            setShowObjective={setShowObjective}
          />
        )
      ) : IS_PROF ? (
        <ObjectiveUpdate action="create" setShowObjective={setShowObjective} />
      ) : (
        <h2>Aucun objectif défini pour le moment</h2>
      )}
    </div>
  );
};

export default ClassObjective;
